import { orchestrator } from 'satcheljs';
import { isFeatureEnabled } from 'owa-feature-flags';
import { LazyInitializeQuickAdd } from 'owa-todos';
import { showTodoPanelWithSubject } from '../actions/showTodoPanelAction';
import { tryTodoPanel } from 'owa-whats-new/lib/actions/tryTodoPanel';
import { trace } from 'owa-trace';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default orchestrator(showTodoPanelWithSubject, actionMessage => {
    const shouldShowTodoPanel =
        isFeatureEnabled('todo-panel') &&
        (!isFeatureEnabled('cal-time-panel') || isFeatureEnabled('mc-smartTask')) &&
        !getUserConfiguration().SessionSettings.IsShadowMailbox;

    if (shouldShowTodoPanel) {
        // Update the todo pane store so the quickAdd item is already populated
        LazyInitializeQuickAdd.importAndExecute(actionMessage.subject, actionMessage.messageId);
        tryTodoPanel();
    } else {
        trace.info(
            '[showTodoPanelWithSubject] Todo panel is not shown for shadow mailbox or feature flight is disabled.'
        );
    }
});
